import * as React from 'react';
import EfLink from '@elem/ui/ef-link';
import EfImg from '@elem/ui/ef-img';
import ArrowIcon from './ArrowIcon';
import { useProductList } from './useProductList';
import styled from './index.module.scss';
import Card from './Card';
import { pageId } from './conf';
import CardKR from './CardKR';
import getLocal from '@/app/utils/getLocal';
import { useLang } from '@/i18n';
import gtm from '@/utils/gtm';

const { Fragment, useMemo } = React;

const Product = () => {
    const { locale } = getLocal();
    const { t } = useLang('membersday.product');
    const { productList } = useProductList(locale);

    const is4multiple = productList?.length >= 4 && productList?.length % 4 === 0;

    const handleShopifyLink = () => {
        try {
            gtm.push({
                event: 'uaEvent',
                event_name: 'buy',
                product_name: 'none',
                position: 'members-festival',
            });
        } catch (err) {
            console.log(err);
        }
    };

    const shopMoreLink = useMemo(() => {
        const links: Record<string, string> = {
            us: 'https://us.ecoflow.com/collections/members-festival',
            ca: 'https://ca.ecoflow.com/collections/members-festival',
            jp: 'https://jp.ecoflow.com/pages/members-festival',
            eu: 'https://eu.ecoflow.com/pages/members-festival',
            uk: 'https://uk.ecoflow.com/pages/members-festival',
            de: 'https://de.ecoflow.com/pages/members-festival',
            fr: 'https://fr.ecoflow.com/pages/members-festival',
            es: 'https://es.ecoflow.com/pages/members-festival',
            it: 'https://it.ecoflow.com/pages/members-festival',
            za: 'https://za.ecoflow.com/pages/easter-members-festival',
            au: 'https://au.ecoflow.com/pages/easter-members-festival',
            kr: 'https://kr.ecoflow.com/pages/members-festival',
        };

        return links[locale] || 'https://us.ecoflow.com/collections/members-festival';
    }, [locale]);

    return (
        <div className={styled.Product} id={pageId}>
            <div className="img-bg">
                <EfImg
                    pc="https://websiteoss.ecoflow.com/upload/image/1742200044605/bg.jpg"
                    pad="https://websiteoss.ecoflow.com/upload/image/1742200419590/bg_pad.jpg"
                    h5="https://websiteoss.ecoflow.com/upload/image/1742200879283/bg_h5.jpg"
                />
            </div>
            <div className="product-content">
                <div className="fy2025-product-title">{t('title')}</div>
                <div className={`product-list-content ${is4multiple ? 'multiple4' : ''}`}>
                    {productList.map((item: any, index: number) => {
                        return item?.productId ? (
                            <Fragment key={item.productId}>{locale === 'kr' ? <CardKR item={item} /> : <Card item={item} />}</Fragment>
                        ) : null;
                    })}
                </div>
                <div className="more-content">
                    <EfLink
                        className=""
                        href={shopMoreLink}
                        onClick={() => {
                            handleShopifyLink();
                        }}
                    >
                        {t('shop_more')}
                    </EfLink>
                    <ArrowIcon className="arrow_icon" />
                </div>
            </div>
        </div>
    );
};

export default Product;
